<template>
    <v-navigation-drawer v-model="drawer" :rail="false" :permanent="mdAndUp" :temporary="!mdAndUp"
        v-if="menu && menu.length > 0">
        <v-list density="compact" nav class="mt-1">
            <v-list-item v-for="(item, index) in menu" :key="index" :prepend-icon="item.img" :title="item.text"
                :active="isActive(item.link)" color="primary" rounded="lg" @click="naviga(item)">

                <!-- <v-badge v-if="richiestePendenti > 0" :content="richiestePendenti" color="error" floating>

                </v-badge> -->

            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useDisplay } from 'vuetify'

export default {
    name: "LeftBarComponent",
    props: {
        menu: { type: Array, default: () => [] },
        modelValue: { type: Boolean, default: true },
    },
    emits: ["esci", "update:modelValue"],

    setup(props, { emit }) {
        const { mdAndUp } = useDisplay()
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        const drawer = ref(props.modelValue);

        watch(() => props.modelValue, (val) => {
            drawer.value = val;
        });

        watch(drawer, (val) => {
            emit("update:modelValue", val);
        });

        function isActive(link) {
            if (!link || !link.startsWith("/")) return false;
            return route.path === link || route.path.startsWith(link + "/");
        }

        function naviga(item) {
            if (item.link && item.link.startsWith("/")) {
                router.push({ path: item.link });
            }
            else if (item.link && item.link.startsWith("@")) {
                if (item.link == "@esci")
                    emit("esci");
            }
        }

        const richiestePendenti = computed(() => store.getters['app/getRichiestePendenti'])

        return {
            drawer,
            mdAndUp,
            isActive,
            naviga,
            richiestePendenti
        };
    },
};
</script>